import { AuditLog } from '../../../../../../../app/ApiGen';

export type DataPoint = { x: number; y: number | null; error?: AuditLogModel['error'] };

export class AuditLogModel implements AuditLog {
  readonly behaviour: AuditLog['behaviour'];

  readonly buyPrice: AuditLog['buyPrice'];

  readonly chargeBelowThreshold: AuditLog['chargeBelowThreshold'];

  readonly doNotChargeAboveThreshold: AuditLog['doNotChargeAboveThreshold'];

  readonly error: AuditLog['error'];

  readonly sellPrice: AuditLog['sellPrice'];

  readonly tags: AuditLog['tags'];

  readonly timestamp: AuditLog['timestamp'];

  constructor(auditLog: AuditLog) {
    const { behaviour, buyPrice, chargeBelowThreshold, doNotChargeAboveThreshold, error, sellPrice, tags, timestamp } =
      auditLog;
    this.behaviour = behaviour;
    this.buyPrice = buyPrice;
    this.chargeBelowThreshold = chargeBelowThreshold;
    this.doNotChargeAboveThreshold = doNotChargeAboveThreshold;
    this.error = error;
    this.sellPrice = sellPrice;
    this.tags = tags;
    this.timestamp = timestamp;
  }

  get maximumNumericalValue(): number {
    const numericalValues = [this.buyPrice, this.chargeBelowThreshold, this.doNotChargeAboveThreshold, this.sellPrice];
    return numericalValues.reduce<number>((max, value) => {
      if (value !== undefined && value > max) {
        return value;
      }
      return max;
    }, 0);
  }

  getBehaviourDataPoint(args: { behaviour: AuditLog['behaviour']; value: number }): DataPoint {
    const { behaviour, value } = args;
    const date = new Date(this.timestamp);
    return { x: date.getTime(), y: this.behaviour === behaviour ? value : null };
  }

  getDataPoint(args: {
    key: Extract<keyof AuditLog, 'buyPrice' | 'sellPrice' | 'chargeBelowThreshold' | 'doNotChargeAboveThreshold'>;
  }): DataPoint {
    const { key } = args;
    const value = this[key];
    const date = new Date(this.timestamp);
    return { x: date.getTime(), y: typeof value === 'number' ? value : null };
  }

  getErrorDataPoint(): DataPoint {
    const date = new Date(this.timestamp);
    return { x: date.getTime(), y: this.error !== undefined ? 0 : null };
  }

  isFromMeterValuesUpdate(): boolean {
    return !!this.tags && this.tags.includes('MeterValues');
  }
}
